module.exports = __webpack_public_path__ + "img/friend@2x.ca1ea193.png";